function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:9px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Letters"
}, /*#__PURE__*/React.createElement("path", {
  d: "M472.11,407.69h-1.75V360.31h1.75Z",
  transform: "translate(-384.87 -85.88)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M523.89,407.69h-1.75l-30.59-44.38v44.38h-1.79V360.31h1.79l30.59,44.29V360.31h1.75Z",
  transform: "translate(-384.87 -85.88)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M552.7,403.07l.95,2.86.94-2.86,15.91-42.76h1.92l-17.7,47.38h-2.15l-17.7-47.38h1.92Z",
  transform: "translate(-384.87 -85.88)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M586.43,407.69h-1.76V360.31h1.76Z",
  transform: "translate(-384.87 -85.88)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M636.29,393.18q-.69,7.32-5,11.24t-11.84,3.92a15.84,15.84,0,0,1-8.93-2.56,16.76,16.76,0,0,1-6-7.25,26,26,0,0,1-2.18-10.76v-7.32a26.44,26.44,0,0,1,2.12-10.82,16.81,16.81,0,0,1,6-7.37,16,16,0,0,1,9-2.6q7.43,0,11.81,3.91t5.08,11.19h-1.76q-.75-6.54-4.55-9.94t-10.58-3.4a13.67,13.67,0,0,0-11.14,5.2q-4.25,5.22-4.25,14v7a24.42,24.42,0,0,0,1.89,9.9,15.32,15.32,0,0,0,5.41,6.72,14,14,0,0,0,8.09,2.41c4.53,0,8.08-1.12,10.62-3.35s4.06-5.59,4.51-10.05Z",
  transform: "translate(-384.87 -85.88)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M681.17,362.07H663.93v45.62h-1.76V362.07H644.92v-1.76h36.25Z",
  transform: "translate(-384.87 -85.88)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M724.69,360.31v32.08q0,7.53-4.36,11.73t-11.81,4.22q-7.46,0-11.81-4.22t-4.4-11.59V360.31h1.76v32q0,6.57,3.95,10.41t10.5,3.84q6.54,0,10.47-3.84t3.94-10.44v-32Z",
  transform: "translate(-384.87 -85.88)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M768.92,396.33a9,9,0,0,0-1.41-5.12,12,12,0,0,0-4.46-3.71,47.05,47.05,0,0,0-9.19-3.3,43.38,43.38,0,0,1-9.23-3.42,12.24,12.24,0,0,1-4.51-4,10.25,10.25,0,0,1-1.43-5.53,9.94,9.94,0,0,1,4.36-8.38q4.37-3.21,11.36-3.21a18.4,18.4,0,0,1,8.18,1.77,13.2,13.2,0,0,1,7.6,12.22h-1.76a11.23,11.23,0,0,0-3.9-8.77,14.69,14.69,0,0,0-10.12-3.46q-6.25,0-10.1,2.78a8.47,8.47,0,0,0-.51,13.85q3.36,2.59,11.06,4.6t11.29,4.64a10.57,10.57,0,0,1,4.56,9,10.42,10.42,0,0,1-2,6.33,12.84,12.84,0,0,1-5.72,4.24,22.07,22.07,0,0,1-8.33,1.5,23.78,23.78,0,0,1-9.24-1.71,13.16,13.16,0,0,1-6.17-4.86,13.3,13.3,0,0,1-2.07-7.46h1.76a10.59,10.59,0,0,0,4.36,9.05q4.37,3.22,11.36,3.22a17.36,17.36,0,0,0,10.25-2.85A8.67,8.67,0,0,0,768.92,396.33Z",
  transform: "translate(-384.87 -85.88)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M802.56,407.69V360.31H815q7.65,0,11.57,3.11t3.92,9a11.33,11.33,0,0,1-2.18,7.12,9.81,9.81,0,0,1-6.15,3.62,11.84,11.84,0,0,1,7.48,3.88,11,11,0,0,1,3,7.57,12.16,12.16,0,0,1-3.92,9.55q-3.93,3.49-10.92,3.5Zm1.76-25.15h11.35q6.48,0,9.76-2.49t3.29-7.73q0-10.1-13.31-10.25H804.32Zm0,1.75v21.64H818q6,0,9.46-3a10.32,10.32,0,0,0,3.43-8.24,9.43,9.43,0,0,0-3.32-7.41,13.38,13.38,0,0,0-8.88-3Z",
  transform: "translate(-384.87 -85.88)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M878.29,393.18q-.69,7.32-5,11.24t-11.84,3.92a15.84,15.84,0,0,1-8.93-2.56,16.82,16.82,0,0,1-6-7.25,26,26,0,0,1-2.18-10.76v-7.32a26.44,26.44,0,0,1,2.12-10.82,16.81,16.81,0,0,1,6-7.37,16,16,0,0,1,9-2.6q7.43,0,11.81,3.91t5.08,11.19h-1.76q-.75-6.54-4.55-9.94t-10.58-3.4a13.67,13.67,0,0,0-11.14,5.2q-4.25,5.22-4.25,14v7a24.42,24.42,0,0,0,1.89,9.9,15.27,15.27,0,0,0,5.42,6.72,13.94,13.94,0,0,0,8.08,2.41c4.53,0,8.08-1.12,10.62-3.35s4.06-5.59,4.51-10.05Z",
  transform: "translate(-384.87 -85.88)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M895.64,407.69h-1.75V360.31h1.75Z",
  transform: "translate(-384.87 -85.88)"
}));

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 298.13,
  cy: 298.13,
  r: 293.63
});

var SvgLoadingLetters = function SvgLoadingLetters(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "invictus_loading",
    viewBox: "0 0 596.25 596.25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoadingLetters, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loading_letters.f5734fc3.svg";
export { ForwardRef as ReactComponent };